import React from 'react';

export default function ReturnToMerchant({ merchant }) {
  return (
    <>
      {merchant && merchant.url &&
        <button
          style={{ maxWidth: "400px", margin: "0 auto", lineHeight: "30px", marginBottom: "30px" }}
          className="button is-ck-blue is-large is-fullwidth has-text-weight-bold"
          onClick={() => window.location.href = merchant.url}
        >
          Return to {merchant.name}
        </button>
      }
    </>
  );
}